import {
  PublicOfferInterestFormDetails,
  SendPublicOfferInterestFormResponse,
} from '@features/public-offer-interest-form/utils/models/public-offer-interest-form.model';
import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import {
  PublicOfferInterestFormActions,
  PublicOfferInterestFormResetActions,
} from '../actions/public-offer-interest-form.actions';

export const publicOfferInterestFormFeatureKey = 'publicOfferInterestForm';

export interface State {
  offerHash: string | null;
  data: PublicOfferInterestFormDetails | null;
  httpState: HttpState;
  send: {
    httpState: HttpState;
    data: SendPublicOfferInterestFormResponse | null;
  };
}

export const initialState: State = {
  offerHash: null,
  data: null,
  httpState: HttpStateHandler.initialState,
  send: {
    httpState: HttpStateHandler.initialState,
    data: null,
  },
};

export const publicOfferInterestFormReducer = createReducer(
  initialState,
  produceOn(PublicOfferInterestFormActions.validateOfferInterestForm, (draft, action) => {
    draft.offerHash = action.offerHash;
    draft.data = initialState.data;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(PublicOfferInterestFormActions.validateOfferInterestFormSuccess, (draft, action) => {
    draft.data = action.data;
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(PublicOfferInterestFormActions.validateOfferInterestFormFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(PublicOfferInterestFormActions.sendOfferInterestForm, (draft, action) => {
    draft.send.data = initialState.send.data;
    draft.send.httpState = HttpStateHandler.loading(draft.send.httpState, action);
  }),
  produceOn(PublicOfferInterestFormActions.sendOfferInterestFormSuccess, (draft, action) => {
    draft.send.data = action.data;
    draft.send.httpState = HttpStateHandler.success(draft.send.httpState, action);
  }),
  produceOn(PublicOfferInterestFormActions.sendOfferInterestFormFailure, (draft, action) => {
    draft.send.httpState = HttpStateHandler.error(draft.send.httpState, action);
  }),
  produceOn(PublicOfferInterestFormResetActions.cancelPublicOfferInterestFormActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(PublicOfferInterestFormResetActions.resetPublicOfferInterestForm, (draft) => {
    draft.offerHash = initialState.offerHash;
    draft.data = initialState.data;
    draft.httpState = initialState.httpState;
    draft.send = initialState.send;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return publicOfferInterestFormReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(publicOfferInterestFormFeatureKey, initialState, false),
];
